function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4 19a1 1 0 002 0V5a1 1 0 00-2 0v14zM4 2h2a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2zm7 17a1 1 0 002 0V9a1 1 0 00-2 0v10zm0-13h2a2 2 0 012 2v12a2 2 0 01-2 2h-2a2 2 0 01-2-2V8a2 2 0 012-2zm7 13a1 1 0 002 0v-4a1 1 0 00-2 0v4zm0-7h2a2 2 0 012 2v6a2 2 0 01-2 2h-2a2 2 0 01-2-2v-6a2 2 0 012-2z"
}));